const UIDataBuilder = require('./ui_data_builder');

const CONST = {
    cssVariationInformativeMessageClasses: 'od-information-message-border prisma-text-md odf-strong odf-space-inner-m odf-space-outer-top-m',
    informativeMessageClasses: 'odf-box odf-box-content odf-box-content-md odf-space-outer-bottom-m odf-text-md odf-space-outer-top-s',
    informativeWarningClass: 'odf-msg-warning',
    informativeInformativeClass: 'odf-msg-informative',
    informativePositiveClass: 'odf-msg-positive-dark',
    primeShiftedMessageClass: 'od-baggage-wrapper-prime-shifted-message',
};

class UIDataBuilderMobile extends UIDataBuilder {
    constructor(constants = {}) {
        super(Odigeo._.merge({}, CONST, constants));
    }

    defaultData(keys) {
        const parentData = super.defaultData(keys);
        return Odigeo._.merge(parentData, {
            parent: {
                selected: {
                    persuasiveMessage: {
                        text: keys.cardMessageAdded,
                        classes: `${this.CONST.positiveText} ${this.CONST.strongText}`,
                    },
                    hint: {
                        asideFeeHint: keys.asideFeeHint,
                        feeHint: keys.feeHint,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativeInformativeClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                    },
                },
                selected: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativeInformativeClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                    },
                },
            },
        });
    }

    noIncludedAndSelectable(keys) {
        const parentData = super.noIncludedAndSelectable(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.cardSubtitleBagsAvailable,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativeWarningClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                        messageIcon: this.CONST.warningIcon,
                        messageTitle: keys.cardMessageNotIncluded,
                        color: this.CONST.warningText,
                    },
                },
                selected: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativePositiveClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                        messageIcon: this.CONST.selectedIcon,
                        messageTitle: keys.cardMessageAdded,
                        color: this.CONST.positiveText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    noIncludedAndNoSelectable(keys) {
        const parentData = super.noIncludedAndNoSelectable(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    title: {
                        text: keys.loadingNotAvailableTitle,
                    },
                    persuasiveMessage: {
                        text: keys.loadingNotAvailableSubtitle,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    allRowsIncludedAndExtra(keys, includedBaggageInformativeMessage) {
        const parentData = super.allRowsIncludedAndExtra(keys, includedBaggageInformativeMessage);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.cardSubtitleAvailable,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageIcon: this.CONST.informationIcon,
                        messageTitle: includedBaggageInformativeMessage,
                        color: this.CONST.infoText,
                    },
                },
                selected: {
                    informativeMessage: {
                        messageIcon: this.CONST.selectedIcon,
                        messageTitle: keys.cardMessageAdded,
                        color: this.CONST.positiveText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    allRowsIncludedAndNoExtra(keys, includedBaggageInformativeMessage) {
        const parentData = super.allRowsIncludedAndNoExtra(keys, includedBaggageInformativeMessage);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.cardSubtitleExtraBagsUnavailable,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageIcon: this.CONST.selectedIcon,
                        messageTitle: includedBaggageInformativeMessage,
                        messageSubtitle: keys.cardSubtitleExtraBagsUnavailable,
                        color: this.CONST.positiveText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    someRowsIncludedAndSelectable(keys, someRowsIncludedAndSelectable) {
        const parentData = super.someRowsIncludedAndSelectable(keys, someRowsIncludedAndSelectable);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.cardSubtitleBagsAvailable,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativeWarningClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                        messageIcon: this.CONST.warningIcon,
                        messageTitle: keys.cardMessageSomeIncludedNegative,
                        color: this.CONST.warningText,
                    },
                },
                selected: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativePositiveClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                        messageIcon: this.CONST.selectedIcon,
                        messageTitle: keys.cardMessageAdded,
                        color: this.CONST.positiveText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    someRowsIncludedAndNoSelectable(keys) {
        const parentData = super.someRowsIncludedAndNoSelectable(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.cardSubtitleExtraBagsUnavailable,
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses, this.CONST.informativeWarningClass].join(' ')
                            : this.CONST.informativeMessageClasses,
                        messageIcon: this.CONST.warningIcon,
                        messageTitle: keys.cardMessageSomeIncludedPositive,
                        messageSubtitle: keys.cardSubtitleExtraBagsUnavailable,
                        color: this.CONST.warningText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    trainStandalone(keys) {
        const parentData = super.trainStandalone(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: keys.trainStandaloneText,
                    },
                },
                selected: {
                    persuasiveMessage: {
                        text: keys.trainStandaloneText,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    promoBadge(keys, primeInfo = {}) {
        const {isPrimeUser, discountAmount} = primeInfo;
        const primeTitleKey = discountAmount > 0 ? keys.discountSaveUpTo : keys.discountUpTo;
        const data = super.promoBadge(keys);

        Odigeo._.merge(data, {
            promoBadgeConfig: [
                {
                    name: 'merchandisingDiscount',
                    offerType: null,
                    title: keys.promoBadgeSpecialOfferMobile,
                    subtitle: null,
                    discountFigure: keys.promoBadgeDiscountFigure || 5,
                    abTest: Odigeo.AB.isPromotionMerchandisingDiscountMobile,
                },
                {
                    name: 'primeAcquisition',
                    title: primeTitleKey,
                    subtitle: null,
                    abTest: Odigeo.AB.isBaggagePrimePriceMobile && !isPrimeUser,
                },
                {
                    name: 'primeRepeat',
                    title: primeTitleKey,
                    subtitle: null,
                    abTest: Odigeo.AB.isBaggagePrimePriceMobile && isPrimeUser,
                },
            ],
        });

        return data;
    }

    isVinFlight(keys, baggageInfo = {}) {
        const data = super.isVinFlight(keys, baggageInfo);

        Odigeo._.merge(data, {
            child: {
                base: {
                    informativeMessage: {
                        messageIcon: this.CONST.informationIcon,
                        messageTitle: keys.vinMessage,
                        color: this.CONST.infoText,
                    },
                },
                selected: {
                    informativeMessage: {
                        messageIcon: this.CONST.informationIcon,
                        messageTitle: keys.vinMessage,
                        color: this.CONST.infoText,
                    },
                },
            },
        });

        return data;
    }

    getDiscountDisplayed(discountPercentage, discountAmount) {
        if (!discountPercentage) {
            return '';
        }

        return discountAmount > 0 ?
            Odigeo.Utils.formatCurrency(discountAmount, {...Odigeo.Utils.Currency, decimalPlaces: 0})
            : `${discountPercentage}%`;
    }

    primeAcquisition(keys, templates, primeInfo = {}) {
        const parentData = super.primeAcquisition(keys, templates, primeInfo);
        const {discountPercentage = 50, discountAmount = 0, savedAmount = 0} = primeInfo;

        return Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: templates.primeAcquisitionPersuasiveMessage({
                            keys: {
                                ...keys,
                                discountKey: keys[discountAmount > 0 ? 'primeAcquisitionBenefitSavings' : 'primeAcquisitionBenefitCheaper'],
                            },
                            discountDisplayed: this.getDiscountDisplayed(discountPercentage, discountAmount),
                        }),
                    },
                },
                selected: {
                    discountInfo: {
                        classes: '',
                        text: templates.primeAcquisitionDiscountInfo({keys, savedAmount}),
                    },
                },
            },
        });
    }

    primeRepeat(keys, templates, primeInfo = {}) {
        const parentData = super.primeRepeat(keys, templates, primeInfo);
        const {savedAmount = 0} = primeInfo;

        return Odigeo._.merge(parentData, {
            parent: {
                base: {
                    persuasiveMessage: {
                        text: templates.primeRepeatPersuasiveMessage({keys, primeInfo}),
                    },
                },
                selected: {
                    discountInfo: {
                        classes: '',
                        text: templates.primeRepeatDiscountInfo({keys, savedAmount}),
                    },
                },
            },
            child: {
                selected: {
                    informativeMessage: {
                        messageAdditionalClasses: Odigeo.AB.isCssVariationMobile
                            ? [this.CONST.cssVariationInformativeMessageClasses,
                                this.CONST.informativePositiveClass, this.CONST.primeShiftedMessageClass].join(' ')
                            : [this.CONST.informativeMessageClasses, this.CONST.primeShiftedMessageClass].join(' '),
                    },
                },
            },
        });
    }
}

module.exports = UIDataBuilderMobile;

